import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { LanguageCodesService } from 'src/app/shared/services/language-codes.service';

import { MarketingDataViewModel } from '@app/api/models';

import { MerchantActions } from '../../store/merchant.slice';

@Component({
  selector: 'app-merchant-marketing-data-card',
  templateUrl: './merchant-marketing-data-card.component.html',
  styleUrls: ['./merchant-marketing-data-card.component.scss'],
})
export class MerchantMarketingDataCardComponent {
  TITLE = 'MERCHANT.TITLE.';
  @Input() data!: MarketingDataViewModel;
  @Input() siteNames!: string[];

  constructor(
    private languageCodesService: LanguageCodesService,
    private store: Store,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  hasKeys(data: any) {
    return data && !!Object.keys(data).length;
  }

  getLangNameByCode(code: string): string {
    return this.languageCodesService.getNameByCode(code);
  }

  delete() {
    this.store.dispatch(
      MerchantActions.deleteMarketingData.trigger({ id: this.data.id })
    );
  }

  edit() {
    this.router.navigate(['edit'], {
      queryParams: { id: this.data.id },
      relativeTo: this.route,
    });
  }
}
